// @vue/component
import { hDeepCopy } from '@/utils/helpers';

export default {
  name: 'MakeCallPopover',

  components: {
  },

  props: {
    agentList: {
      type: Array,
      default: () => [],
    },
    isAnyAgentAbleToCall: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isLoading: false,
      isMakingCall: false,
      isError: false,
      isNoAccess: false,
      isPopoverVisible: false,
      callTimeout: null,
      connectionDetails: {
        id: '',
        numberA: '',
        numberB: '',
        status: '',
        stamp: '',
        selectedAgent: '',
        method: '',
        agentName: '',
        endTime: '',
        numberRevers: '',
      },
    };
  },
  computed: {
    isAllDataFilled() {
      return (this.agentList.length === 1 ? false : this.connectionDetails.selectedAgent === '')
      || (this.connectionDetails.numberB.length < 9);
    },
  },
  created() {
    this.$socket.$emit('getCurrentMassdialActiveRecord', {
      userUuid: this.$store.getters['authorization/user'].user_uuid,
    });

    this.$socket.$on('getCurrentMassdialActiveRecord', async (payload) => {
      if (payload == null) {
        this.clearData();
        this.isMakingCall = false;
      } else {
        this.isMakingCall = true;
        this.fillConnectionData(payload);
      }
      this.$EventBus.$emit('MakeCallPopover/IS_ANY_CALLING_RECORD', this.isMakingCall);
    });

    this.$socket.$on('massdialRecordChange', async (payload) => {
      if (payload.end_time !== null) {
        this.clearData();
        this.isMakingCall = false;
      } else {
        this.isMakingCall = true;
        this.fillConnectionData(payload);
      }
      this.$EventBus.$emit('MakeCallPopover/IS_ANY_CALLING_RECORD', this.isMakingCall);
    });
  },
  beforeDestroy() {
    this.$socket.$offAll(['massdialRecordChange', 'getCurrentMassdialActiveRecord']);
  },
  methods: {
    async stopCalling() {
      await this.$store.dispatch('user/agent/stopCalling', this.connectionDetails.uuid);
    },
    fillConnectionData(data) {
      this.connectionDetails = {
        ...this.connectionDetails,
        id: data.id,
        uuid: data.uuid,
        numberA: data.numa,
        numberB: data.numb,
        status: data.status,
        stamp: data.stamp,
        agentName: data.agent_name,
        numberRevers: data.numb_revers,
        selectedAgent: data.agent_uuid,
      };
    },
    onlyNumber($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        $event.preventDefault();
      }
    },
    async makeCall() {
      this.isLoading = true;
      const agentUuid = this.agentList.length === 1 ? this.agentList[0].uuid : this.connectionDetails.selectedAgent;
      this.connectionDetails.method = this.getAgentDetails(agentUuid).massdial4call_methods;

      if (agentUuid !== '' && this.connectionDetails.numberB.length === 9) {
        const params = {
          agent: agentUuid,
          number_b: this.connectionDetails.numberB,
        };
        const result = await this.$store.dispatch('user/agent/makeCall', params);
        this.isLoading = false;

        if (result.status === 200) {
          if (result.data.data === 0) {
            this.isNoAccess = true;
          } else {
            this.isMakingCall = true;
          }
        } else {
          this.isError = true;
        }
      }
    },
    clearData() {
      this.connectionDetails.numberB = '';
      this.connectionDetails.selectedAgent = '';
      clearTimeout(this.timeout);
    },
    closeErrorWindow() {
      this.isPopoverVisible = false;
      this.isError = false;
      clearTimeout(this.timeout);
    },
    getAgentDetails(agentUuid) {
      return hDeepCopy(this.agentList).filter(agent => agent.uuid === agentUuid)[0];
    },
  },
};
